export const iconFontAwesomePoliticalFlagUsa = (
	<i className="fa-solid fa-flag-usa"></i>
);
